<template>
  <div>
    <div class="product-container" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <div class="product-detail product-detail--featured">
        <backlink/>
        <div class="product-detail__image-container">
          <span class="product-detail__close-swiper-fullscreen" v-if="this.swiperFullScreen == true" @click="closeSliderFullscreen"><img src="/static/img/pictos/croix-blanche.svg" alt=""/></span>
          <span class="product-detail__open-swiper-fullscreen" v-else @click="openSliderFullscreen"><img src="/static/img/pictos/loupe.svg" alt=""/></span>
          <div :class="'swiper-container swiper-container--images swiper-container--' + $store.getters['auth/role']+ ' swiper-container--size'+ this.swiperFullScreen">
            <div class="swiper-wrapper" v-if="detail.photos && detail.photos.length > 0">
                <!-- Slides -->
              <div class="swiper-slide" v-on:click="openSliderFullscreen" v-for="photo in detail.photos" v-if="photo.name"><div class="swiper-zoom-container"><img class="product-detail__image" alt="" :src="imagesurl+'600/'+photo.name"></div></div>
            </div>
            <div class="swiper-wrapper" v-else>
              <div class="swiper-slide" v-on:click="openSliderFullscreen"><div class="swiper-zoom-container"><img class="product-detail__image" alt="" src="/static/img/1000x667.jpg"></div></div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="product-detail__info-container">
          <div class="product-detail__info-main">
            <div class="product-detail__name-container">
              <h3 class="product-detail__name desktop">
                <a v-if="myFavoritesProducts.includes(detail.id) || fav == 1" class="product-detail__favorite"  href="" @click.prevent="removeFromFavorites(detail.id)"><img src="/static/img/pictos/produitfavorisfondvert.svg" alt=""></a>
                <a v-else class="product-detail__favorite"  href="" @click.prevent="addToFavorites(detail.id)"><img src="/static/img/pictos/produitnonfavoris.svg" alt=""></a>
                <span>{{ detail.label }}</span>
              </h3>
            </div>
            <div class="product-detail__price-container desktop">
              <span class="product-detail__price"><strong>
                <div v-for="(item) in detail.prices">
                    <span v-if="item.entrepriseDescription == 'MCI'">{{item.price}}</span>
                </div>
              </strong> <sup><strong>€</strong> HT</sup></span>
              <p class="product-detail__price-text">Prix à l'unité</p>
            </div>
          </div>
          <p class="product-detail__code">Code article : {{ detail.code }}</p>
          <div class="product-detail__stock-container">
            <p class="product-detail__stock stock">
              Etat du stock
              <div v-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock == 0" class="stock__picto magasin red"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock <= 10" class="stock__picto magasin orange"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.productShops && detail.productShops[0]" class="stock__picto magasin green"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <span class="stock__number" v-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock">{{ detail.productShops[0].stock }}</span>
            </p>
          </div>
          <div class="product-detail__btns" v-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock != 0">
            <div class="product-detail__quantity-container quantity">
              <span class="quantity__text">Quantité : </span>
              <input type="text" class="quantity__value" name="" v-model="qt" value="1">
            </div>
            <ProductAddToCart :item="detail" :detail="true" :quantity="qt" class="product-detail__btn">
              <span>Ajouter au panier</span>
              <img src="/static/img/pictos/panier.svg" alt="">
            </ProductAddToCart>
          </div>
          <div class="product-detail__description description">
            <div class="description__header">
              <span>Description</span>
              <a v-if="detail.description && detail.description.length > 0" href="" :class="'description__btn deployed--'+showDescription" @click.prevent="showDescription = !showDescription">Voir toutes les informations</a>
            </div>
            <div class="description__text" v-if="showDescription == 1">
              <p>{{ detail.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="product-detail__technical-infos technical">
        <div class="technical__btns">
          <a v-if="detail.specifications && detail.specifications.length > 0" href="#" class="technical__btn" @click.prevent="showTechnicalCarac = 1 ; showTechnicalInfo = 0">
            <span class="btn__text">Caractéristiques techniques</span>
            <span class="btn__arrow-container"><img src="/static/img/pictos/flecheblanche.svg" alt=""></span>
          </a>
          <a v-if="detail.documents && detail.documents.length > 0" href="#" class="technical__btn" @click.prevent="showTechnicalCarac = 0 ; showTechnicalInfo = 1">
            <span class="btn__text">Fiche technique</span>
            <span class="btn__arrow-container"><img src="/static/img/pictos/flecheblanche.svg" alt=""></span>
          </a>
        </div>
        <div class="technical__content" >
          <table v-if="showTechnicalCarac == 1">
            <tr v-for="carac in detail.specifications">
              <td>{{ carac.name }}</td><td>{{ carac.value }}</td>
            </tr>
          </table>
          <div v-if="showTechnicalInfo == 1">
            <div class="" v-for="document in detail.documents" v-if="document.name">
              <a class="product-detail__image" alt="" :src="imagesurl+'/'+document.name">doc</a>
            </div>
          </div>
        </div>
      </div>
      <div class="associated-products-container" v-show="detail.associatedProducts && detail.associatedProducts.length > 0">
        <div class="associated-products">
          <h2 class="associated-products__title">Les produits associés</h2>
          <div :class="'swiper-container swiper-container--associated-products swiper-container--' + $store.getters['auth/role']">
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="item in detail.associatedProducts" :key="item">
                  <ProductFavorites :id="item" :class="'product--fullwidth product--no-border'"></ProductFavorites>
                </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="product-container product-container--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <div class="product-detail product-detail--featured">
        <div class="product-detail__image-container">
          <span class="product-detail__close-swiper-fullscreen" v-if="this.swiperFullScreen == true" @click="closeSliderFullscreen"><img src="/static/img/pictos/croix-blanche.svg" alt=""/></span>
          <span class="product-detail__open-swiper-fullscreen" v-else @click="openSliderFullscreen"><img src="/static/img/pictos/loupe.svg" alt=""/></span>
          <div :class="'swiper-container swiper-container--images swiper-container--' + $store.getters['auth/role']+ ' swiper-container--size'+ this.swiperFullScreen">
            <div class="swiper-wrapper" v-if="detail.photos && detail.photos.length > 0">
                <!-- Slides -->
                <div class="swiper-slide" v-on:click="openSliderFullscreen" v-for="photo in detail.photos" v-if="photo.name"><div class="swiper-zoom-container"><img class="product-detail__image" alt="" :src="imagesurl+'600/'+photo.name"></div></div>
            </div>
            <div class="swiper-wrapper" v-else>
              <div class="swiper-slide" v-on:click="openSliderFullscreen"><div class="swiper-zoom-container"><img class="product-detail__image" alt="" src="/static/img/1000x667.jpg"></div></div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="product-detail__info-container">
          <div class="product-detail__info-main">
            <div class="product-detail__name-container">
              <h3 class="product-detail__name">{{ detail.label }}</h3>
              <a v-if="myFavoritesProducts.includes(detail.id) || fav == 1" class="product-detail__favorite"  href="" @click.prevent="removeFromFavorites(detail.id)"><img src="/static/img/pictos/produitfavorisfondvert.svg" alt=""></a>
              <a v-else class="product-detail__favorite"  href="" @click.prevent="addToFavorites(detail.id)"><img src="/static/img/pictos/produitnonfavoris.svg" alt=""></a>
            </div>
          </div>
          <p class="product-detail__code"><img src="/static/img/pictos/reapprobleufonce.svg" alt="" v-if="detail.vehicleStocks && detail.vehicleStocks.length == 1 && detail.vehicleStocks[0].restocking == 1"> <span>Code article : {{ detail.code }}</span></p>
          <div class="product-detail__stock-container">
            <p class="product-detail__stock stock">
              Etat du stock :
              <div v-if="detail.vehicleStocks && detail.vehicleStocks[0] && detail.vehicleStocks[0].stock < detail.vehicleStocks[0].minStock" class="stock__picto vehicle red"><img src="/static/img/pictos/camionstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.vehicleStocks && detail.vehicleStocks[0] && detail.vehicleStocks[0].stock == detail.vehicleStocks[0].minStock" class="stock__picto vehicle orange"><img src="/static/img/pictos/camionstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.vehicleStocks && detail.vehicleStocks[0]" class="stock__picto vehicle green"><img src="/static/img/pictos/camionstockssbulle.svg" alt="" ></div>
              <span class="stock__number" v-if="detail.vehicleStocks && detail.vehicleStocks[0]">{{ detail.vehicleStocks[0].stock }}</span>

              <div v-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock == 0" class="stock__picto magasin red"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.productShops && detail.productShops[0] && detail.productShops[0].stock <= 10" class="stock__picto magasin orange"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <div v-else-if="detail.productShops && detail.productShops[0]" class="stock__picto magasin green"><img src="/static/img/pictos/magasinstockssbulle.svg" alt="" ></div>
              <span class="stock__number" v-if="detail.productShops && detail.productShops[0]">{{ detail.productShops[0].stock }}</span>
            </p>
          </div>
          <div class="product-detail__btns">
            <a class="product-detail__btn product-detail__btn--reappro" v-if="detail.vehicleStocks && detail.vehicleStocks.length == 1 && detail.vehicleStocks[0].restocking == 1">
              <span>Dans mon réappro</span>
              <img src="/static/img/pictos/validerrondblanc.svg" alt="">
            </a>
            <a href="" v-else-if="$store.getters['auth/user'].min_max_stock_management" class="product-detail__btn product-detail__btn--reappro" @click.prevent="showModalAdd = 1" v-else>
              <span>Ajouter au réappro</span>
              <img src="/static/img/pictos/reappro.svg" alt="">
            </a>
            <a href="" class="product-detail__btn product-detail__btn--cart" @click.prevent="showProductAddModal = 1">
              <span>Ajouter au panier</span>
              <img src="/static/img/pictos/panier.svg" alt="">
            </a>
          </div>
          <div class="product-detail__description description">
            <div class="description__header">
              <span>Description</span>
              <a href="" v-if="detail.description" :class="'description__btn deployed--'+showDescription" @click.prevent="showDescription = !showDescription">Voir toutes les informations</a>
            </div>
            <div class="description__text" v-if="showDescription == 1">
              <p>{{ detail.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="product-detail__technical-infos technical">
        <div class="technical__btns">
          <a href="#" class="technical__btn" @click.prevent="showTechnicalCarac = !showTechnicalCarac">
            <span class="btn__text">Caractéristiques techniques</span>
            <span class="btn__arrow-container"><img :class="'rotate--'+showTechnicalCarac" src="/static/img/pictos/flecheblanche.svg" alt=""></span>
          </a>
          <div class="technical__content" v-if="showTechnicalCarac == 1">
            <table>
              <tr v-for="carac in detail.specifications">
                <td>{{ carac.name }}</td><td>{{ carac.value }}</td>
              </tr>
            </table>
          </div>
          <a href="#" class="technical__btn" @click.prevent="showTechnicalInfo = !showTechnicalInfo">
            <span class="btn__text">Fiche technique</span>
            <span class="btn__arrow-container"><img :class="'rotate--'+showTechnicalInfo" src="/static/img/pictos/flecheblanche.svg" alt=""></span>
          </a>
          <div class="technical__content" v-if="showTechnicalInfo == 1">
            <div class="" v-for="document in detail.documents" v-if="document.name">
              <a class="product-detail__image" alt="" :href="imagesurl+'/'+document.name" target="_blank"><img class="" src="/static/img/pictos/file.svg" alt=""></a>
            </div>
          </div>
        </div>
      </div>
      <div class="associated-products-container" v-show="detail.associatedProducts && detail.associatedProducts.length > 0">
        <div class="associated-products">
          <h2 class="associated-products__title">Les produits associés</h2>
          <div :class="'swiper-container swiper-container--associated-products swiper-container--' + $store.getters['auth/role']">
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="item in detail.associatedProducts" :key="item">
                  <ProductFavorites :id="item" :class="'product--fullwidth product--no-border'"></ProductFavorites>
                </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <ProductFavoritesSwiper></ProductFavoritesSwiper>
      <ReapproAddModal v-if="showModalAdd == 1" @close="showModalAdd = 0" :item="detail"></ReapproAddModal>
      <ProductAddModal v-if="showProductAddModal == 1" @close="showProductAddModal = 0" :item="detail"></ProductAddModal>
    </div>
  </div>
</template>

<script>
import Product from "@/components/Product/Product";
import ProductFavorites from "@/components/Product/ProductFavorites";
import ProductAddToCart from "@/components/Product/ProductAddToCart";
import ReapproAddModal from "@/components/Reappro/ReapproAddModal";
import ProductAddModal from "@/components/Product/ProductAddModal";
import ProductFavoritesSwiper from "@/components/Product/ProductFavoritesSwiper";

export default {
  name: "ProductDetail",
  data() {
    return {
      qt: 1,
      showProductAddModal: 0,
      showModalAdd: 0,
      detail: {
        id: null,
        label: null,
        prices: null,
      },
      showTechnicalCarac: 0,
      showTechnicalInfo: 0,
      showDescription: 0,
      fav: 0,
      swiperFullScreen: 0,
    };
  },
  components: {
    Product,
    ProductFavorites,
    ProductAddToCart,
    ReapproAddModal,
    ProductAddModal,
    ProductFavoritesSwiper,
  },
  created() {
    this.$store.dispatch("hideSearch");
    this.$store.dispatch("hideHomeSearch");
  },
  computed: {
    items: function () {
      let items = this.$store.getters["product/getAllCurrent"];

      if (items) {
        this.totalRows = items.length;
        return items;
      }
    },
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
    myFavoritesProducts: function () {
      return this.$store.getters["auth/myFavoritesProducts"];
    },
    me: function () {
      let me = this.$store.getters["auth/user"];

      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
  },
  mounted() {
    const self = this;
    this.fav = 0;

    this.$store.dispatch("product/getAllCurrent").then(() => {
      this.detail = this.$store.getters["product/getItemCurrent"](this.$route.params.id);
      this.initAssociatedPhotosSwiper();
      this.initImagesSwiper();
      this.$store.dispatch("hideLoader");
    });

    this.$store.dispatch("auth/getCurrentUser");
  },
  methods: {
    addToFavorites(id) {
      this.fav = 1;
      this.$http
        .post("user/addfavorite", {
          product: { id: id },
        })
        .then((response) => {
          this.$store.dispatch("auth/getMyFavoritesProducts");
        });
    },
    openSliderFullscreen() {
      this.swiperFullScreen = 1;
    },
    closeSliderFullscreen() {
      this.swiperFullScreen = 0;
    },
    removeFromFavorites(id) {
      this.$http.delete("user/removefavorite/" + id, {}).then((response) => {
        this.$store.dispatch("auth/getMyFavoritesProducts");
      });
    },
    initAssociatedPhotosSwiper() {
      if (this.$store.getters["auth/isRole"]("ROLE_AGENT") == true) {
        const swiper = new Swiper(".swiper-container--associated-products", {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
          preventClicks: false,
          preventClicksPropagation: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
        });
      } else if (this.$store.getters["auth/isRole"]("ROLE_TECHNICIAN") == true) {
        const swiper = new Swiper(".swiper-container--associated-products", {
          slidesPerView: 1,
          slidesPerGroup: 1,
          preventClicks: false,
          preventClicksPropagation: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
        });
      }
    },
    initImagesSwiper() {
      const swiperImages = new Swiper(".swiper-container--images", {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          observer: true,
        },
        zoom: {
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: "swiper-zoom-container",
        },
      });
    },
  },
  watch: {
    // Cas spécial car, à cause du champ de recherche général, on peut passer directement d'un détail à un autre.
    // Dans ce cas, le component n'est pas rechargé, il faut donc lancer le rechargement des bonnes données manuellement
    $route(to, from) {
      const self = this;
      this.fav = 0;
      this.$store.dispatch("hideSearch");
      this.detail = this.$store.getters["product/getItemCurrent"](this.$route.params.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";
@import "/static/swiper/css/swiper.min.css";

table {
  width: 100%;
  margin-bottom: 20px;
  tr {
    border-bottom: 1px solid $grisclair;
    td {
      font-family: "ClanPro";
      font-size: 12px;
      padding: 5px 0;
    }
    &:last-of-type {
      border-bottom: 0;
    }
  }
}

.product-container {
  &--mobile {
    padding-top: 30px;
    margin-top: 75px;
    overflow: hidden;
    .product-detail {
      &__image-container {
        width: 100%;
      }
      &__info-container {
        width: 100%;
        padding: 40px 0 0 0;
      }
      &__name {
        font-size: 16px;
        flex: 1;
      }
      &__name-container {
        display: flex;
        align-items: center;
      }
      &__favorite {
        width: 50px;
        margin-left: 0;
        img {
          width: 50px;
        }
      }
      .description {
        margin-top: 80px;
        &__header {
          span {
            font-size: 16px;
            font-family: "ClanPro";
          }
        }
        &__btn {
          width: 50%;
        }
      }
      &__stock {
        margin-bottom: 0;
        font-size: 12px;
        margin-right: 10px;
      }
      &__stock-container {
        border-bottom: 1px solid $color1;
        padding: 0;
        height: 50px;
        display: flex;
        align-items: center;
        span {
          font-size: 20px;
          margin-right: 10px;
        }
        .stock__picto {
          img {
            width: 20px;
          }
          &.vehicle {
            img {
              width: 27px;
            }
          }
        }
      }
      &__btn {
        &--reappro {
          width: auto;
          text-align: center;
          height: 70px;
          color: white;
          padding: 0 30px;
          background-color: $color4;
          display: flex;
          align-items: center;
          line-height: auto;
          img {
            width: 40px;
          }
          span {
            font-family: "ClanProBold";
            font-size: 14px;
            margin-right: 20px;
          }
          &:hover {
            text-decoration: none;
          }
        }
        &--cart {
          width: auto;
          text-align: center;
          height: 70px;
          color: white;
          padding: 0 30px;
          background-color: $color3;
          display: flex;
          align-items: center;
          line-height: auto;
          img {
            width: 40px;
          }
          span {
            font-family: "ClanProBold";
            font-size: 14px;
            margin-right: 20px;
          }
          &:hover {
            text-decoration: none;
          }
        }
      }
      &__btns {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        z-index: 11;
        .product-detail__btn {
          width: 50%;
          justify-content: space-between;
          line-height: 1;
          span {
            line-height: 1;
            text-align: left;
          }
        }
      }
      &__info-main {
        .product-detail__name-container {
          width: 100%;
          margin-bottom: 15px;
        }
      }
      &__code {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 15px;
        }
        span {
          font-size: 12px;
          margin-top: 4px;
        }
      }
    }
    .product-detail--featured {
      width: 100%;
      padding: 20px;
    }
    .associated-products-container {
      width: 100%;
      padding: 40px 20px;
      .associated-products {
        &__title {
          padding-bottom: 0;
          margin-bottom: 15px;
          font-size: 18px;
          &:before {
            content: none;
          }
        }
        .swiper-slide {
          width: 100%;
          margin-right: 0;
          .product {
            border: none;
          }
        }
      }
    }
    .technical {
      width: 100%;
      padding: 20px;
      &__btns {
        width: 100%;
      }

      &__content {
        width: 100%;
        padding: 0 20px;
      }
    }
  }
}
.technical {
  width: 86%;
  margin: 0 auto 80px;
  display: flex;
  &__btns {
    width: 40%;
    display: flex;
    flex-direction: column;
  }
  &__btn {
    font-family: "ClanFFBlack";
    color: $color1;
    font-size: 16px;
    border-bottom: 1px solid $color1;
    height: 50px;
    margin-bottom: 30px;
    display: flex;
    &:hover {
      text-decoration: none;
    }
    .btn__text {
      flex: 1;
      padding-top: 10px;
    }
    .btn__arrow-container {
      height: 100%;
      width: 80px;
      background-color: $color1;
      display: flex;
      justify-content: center;
      img {
        width: 20px;
        transition: transform 100ms ease-in;
        &.rotate--true {
          transform: rotate(90deg);
        }
        &.rotate--false {
          transform: rotate(0);
        }
      }
    }
  }
  &__content {
    width: 60%;
    padding: 0 0 50px 70px;
    p {
      font-size: 12px;
    }
  }
}
.product-detail {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  align-items: stretch;
  &--featured {
    width: 86%;
    margin: 0 auto;
  }
  &__image-container {
    width: 40%;
    height: 100%;
    border: 1px solid $grisclair;
    position: relative;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 60%;
    height: 100%;
    padding: 0 0 70px 7%;
    background-color: white;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product-detail__name-container {
      width: 70%;
      line-height: 1;
    }
    .product-detail__price-container {
      width: 30%;
      text-align: left;
      line-height: 1;
      padding-left: 20px;
    }
  }
  &__close-swiper-fullscreen {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 30px;
    right: 30px;
    font-size: 30px;
    z-index: 1000;
    background-color: $color1;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  &__open-swiper-fullscreen {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 15px;
    right: 15px;
    font-size: 30px;
    z-index: 8;
    background-color: $color2;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  &__stock-container {
    border-top: 1px solid $color1;
    padding-top: 15px;
    display: flex;
    align-items: last baseline;
  }
  &__favorite {
    width: 50px;
    margin-left: 0;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
    img {
      width: 50px;
    }
  }
  &__name {
    font-size: 25px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
    &.desktop {
      display: flex;
      margin-bottom: 40px;
      span {
        margin-left: 10px;
      }
    }
  }
  &__stock {
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
  }
  .stock {
    &__number {
      color: $grisfonce;
      font-family: "ClanFFBlack";
      font-size: 15px;
    }
    &__picto {
      margin: 0 10px;
      position: relative;
      &:before {
        content: "";
        display: block;
        width: 12px;
        height: 12px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -3px;
        margin-top: -3px;
        border-radius: 50%;
      }
      img {
        width: 14px;
        vertical-align: top;
        margin-top: 2px;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
    }
  }
  &__price-container {
  }
  &__price {
    font-size: 40px;
    color: $color2;
    white-space: nowrap;
    strong {
      font-family: "ClanFFBlack";
      font-weight: normal;
    }
    sup {
      font-size: 14px;
      font-family: "ClanPro";
    }
  }
  &__price-text {
    font-size: 14px;
    font-family: "ClanPro";
    color: $color2;
  }
  &__code {
    font-size: 14px;
    color: $grisfonce;
    font-family: "ClanPro";
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-end;
  }
  .quantity {
    flex: 1;
    justify-content: flex-end;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 30px;
    &__text {
      color: $grisfonce;
      font-family: "ClanPro";
      text-transform: uppercase;
      font-size: 12px;
    }
    &__value {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      border-radius: 50%;
      background-color: $grisclair;
      line-height: 50px;
      text-align: center;
      border: none;
      outline: none;
      font-family: "ClanFFBlack";
      font-weight: normal;
      color: $color1;
    }
  }

  &__btn {
    width: auto;
    text-align: center;
    height: 70px;
    color: white;
    padding: 0 30px;
    &--add {
      background-color: $color3;
      display: flex;
      align-items: center;
      img {
        width: 40px;
      }
      span {
        font-family: "ClanProBold";
        font-size: 14px;
        margin-right: 20px;
      }
      &:hover {
        text-decoration: none;
      }
    }
  }
  .description {
    margin-top: 80px;
    &__header {
      border-bottom: 1px solid $color3;
      display: flex;
      align-items: center;
      width: 100%;
      span {
        font-size: 20px;
        flex: 1;
        align-self: flex-end;
      }
    }
    &__btn {
      padding: 0 18px;
      height: 55px;
      line-height: 55px;
      border: 1px solid $color3;
      border-bottom: none;
      font-family: "ClanProBold";
      font-size: 14px;
      color: $color3;
      &:hover {
        text-decoration: none;
      }
      &.deployed--true {
        background-color: $color3;
        color: white;
      }
    }
    &__text {
      padding-top: 20px;
      p {
        font-size: 12px;
      }
    }
  }
}
.associated-products-container {
  padding: 95px 7%;
  background-color: $color1;
  margin-bottom: 100px;
  .associated-products {
    position: relative;
    &__title {
      font-family: "ClanFFBlack";
      color: white;
      font-size: 20px;
      margin-bottom: 50px;
      position: relative;
      padding-bottom: 30px;
      &:before {
        content: "";
        display: block;
        width: 60px;
        height: 8px;
        background-color: white;
        border-radius: 4px;
        position: absolute;
        bottom: 0;
      }
    }
    .swiper-slide {
      width: calc(50% - 15px);
    }
    .swiper-button-prev {
      left: -40px;
      margin-top: 5px;
      width: 15px;
      background-size: contain;
      outline: none;
    }
    .swiper-button-next {
      right: -40px;
      margin-top: 5px;
      width: 15px;
      background-size: contain;
      outline: none;
    }
  }
}
.swiper-container--images {
  .swiper-slide {
    height: 250px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  &.swiper-container--size1 {
    background-color: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    .swiper-slide {
      height: 100%;
      width: 100% !important;
      img {
        object-fit: contain;
      }
    }
  }
}
@media screen and (max-width: 550px) {
  .product-detail {
    .description__btn {
      font-size: 14px;
      padding: 0 30px;
      width: 50%;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: left;
    }
  }
}
@media screen and (max-width: 400px) {
  .product-detail {
    .description__header {
      span {
        margin-right: 20px;
        font-size: 14px;
        flex: 1;
      }
    }
    .description__btn {
      font-size: 13px;
      padding: 0 10px;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: left;
      width: 50%;
    }
    &__btn {
      padding: 0 15px;
      &.product-detail__btn--reappro {
        padding: 0 15px;
      }
    }
  }
}
@media screen and (max-width: 370px) {
  .product-detail {
    &__btn {
      padding: 0 10px;
      &.product-detail__btn--reappro {
        padding: 0 10px;
        span {
          margin-right: 5px;
        }
      }
      span {
        margin-right: 5px;
      }
    }
  }
  .technical__btns {
    .technical__btn {
      span {
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductDetail.vue